import { registerLocale } from 'i18n-iso-countries'
import en from 'i18n-iso-countries/langs/en.json'
import nl from 'i18n-iso-countries/langs/nl.json'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import XHR from 'i18next-xhr-backend'
import { initReactI18next } from 'react-i18next'

import { APP_CONFIG } from '../../env-cmdrc'
/**
 * @see https://github.com/i18next/react-i18next/blob/master/example/react/src/
 */

const isLocalhost = window.location.hostname === 'localhost'
const basePath = isLocalhost ? '' : '/v2'
i18n
  .use(XHR)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ns: ['app', 'common', 'di'],
    lng: 'en',
    fallbackLng: 'en',
    preload: ['en'],
    defaultNS: 'app',
    fallbackNS: 'app',
    backend: {
      loadPath:
        APP_CONFIG.APP_BASE_URL +
        basePath +
        `/locales/{{lng}}/{{ns}}.json?v=2.9.6`,
    },
  })

registerLocale(en)
registerLocale(nl)

export default i18n
